import { useQuery } from 'react-query';
import { allBoostsQuery } from './useAllBoosts.query';
import { UseAllBoostsOptions } from './useAllBoosts.types';
import { Boost } from '../../../types/models/boosts/boosts.types';

export const ALL_BOOSTS_QUERY_KEY = 'ALL_BOOSTS';

export const useAllBoosts = (options?: UseAllBoostsOptions) => {
  return useQuery<Boost[], Error>(ALL_BOOSTS_QUERY_KEY, () => allBoostsQuery(), options);
};
